import { Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { CustomSearchbar } from '../../common/CustomSearchbar';
import PassDownloadTemplatesListFilter from './PassDownloadTemplatesListFilter';
import PassDownloadTemplatesListContext from '../../../store/client/PassDownloadTemplateListContext';
import useOrganizationStatus from '../../../hooks/useOrganisationStatus';
import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

const PassDownloadTemplatesHeader = (props) => {
  const passDownloadTemplatesListCtx = useContext(
    PassDownloadTemplatesListContext
  );
  const filters = getFiltersString(passDownloadTemplatesListCtx.filterValues);
  const [loadingDashHeader, setLoadingDashHeader] = useState(true);
  const [loadingDashBody, setLoadingDashBody] = useState(true);
  const filterModeColor = useColorModeValue('secondaryDark08', 'white');
  const { shouldRender } = useOrganizationStatus();
  const isReadOnly = useIsReadOnly();

  function getFiltersString(filters) {
    const { passTemplate } = filters;
    if (passTemplate === '' || passTemplate === undefined) {
      return '';
    }

    let values = [];

    if (passTemplate !== '') {
      values.push(passTemplate);
    }

    const count = values.length;
    let outString = '';
    values.forEach((value, index) => {
      if (index === count - 1) {
        outString = outString + value;
      } else {
        outString = outString + value + ', ';
      }
    });

    return outString;
  }

  return (
    <>
      <PageHeadingWithTrialProgress
        title={
          <>
            {filters === '' ? 'Pass download pages' : `Filter results: `}
            <Text
              as="span"
              display="inline-block"
              textStyle="bodyFamilyMedium"
              fontSize="16px"
              color={filterModeColor}
              wordBreak="break-word"
            >
              {filters}
            </Text>
          </>
        }
      />
      {shouldRender && (
        <Flex
          direction={{ base: 'column', sm: 'row' }}
          w="100%"
          justifyContent="space-between"
          mb="10px"
        >
          <CustomSearchbar
            handleInputSearch={props.handleInputSearch}
            setInputSearch={props.setInputSearch}
            type="pass-download-page"
            w={{ base: '100%', sm: '400px' }}
          />
          <Flex w={{ base: '100%', sm: 'unset' }} justify="flex-start">
            {isReadOnly ? (
              <LockedActionButton
                reason="download-templates"
                alignSelf={{ base: 'flex-start', sm: 'center' }}
                mt={{ base: '12px', sm: '0' }}
                px={{ base: '17px', sm: '30px' }}
                size="sm"
                minW="180px"
                mr={{ base: '5px', sm: '15px' }}
              >
                Create page
              </LockedActionButton>
            ) : (
              <Button
                alignSelf={{ base: 'flex-start', sm: 'center' }}
                mt={{ base: '12px', sm: '0' }}
                px={{ base: '17px', sm: '30px' }}
                alt="Create pass download page"
                size="sm"
                as={RouterLink}
                to="/pass-download-pages/create"
                minW="180px"
                mr={{ base: '5px', sm: '15px' }}
                flexGrow="1"
              >
                Create page
              </Button>
            )}
            <PassDownloadTemplatesListFilter
              loadingDashHeader={loadingDashHeader}
              loadingDashBody={loadingDashBody}
              setLoadingDashBody={setLoadingDashBody}
              setLoadingDashHeader={setLoadingDashHeader}
            />
          </Flex>
        </Flex>
      )}
    </>
  );
};
export default PassDownloadTemplatesHeader;
